export { PromptIsland } from "./PromptIsland";
export type { FileAttachment, PromptIslandProps } from "./types";
